import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "12",
  fill: "currentColor",
  viewBox: "0 0 16 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M.584 1a.75.75 0 0 1 .75-.75h13.333a.75.75 0 0 1 0 1.5H1.334A.75.75 0 0 1 .584 1m0 10a.75.75 0 0 1 .75-.75h13.333a.75.75 0 0 1 0 1.5H1.334a.75.75 0 0 1-.75-.75m7.417-5.75h6.666a.75.75 0 0 1 0 1.5H8.001a.75.75 0 0 1 0-1.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }